import palette from '../palette';

export default {
    root: {
        backgroundColor: '#F2F5FB'
    }
};
